import throttle from 'lodash/throttle'

class HeaderSite {
  constructor() {
    this.root = document.querySelector('.HeaderSite');
    if (!this.root) return;

    this.mobileMenu = document.querySelector('.HeaderMobile');
    this.mobileOpen = false;
    this.mainMenu = this.root.querySelector('.HeaderSite-inner');
    this.menuContents = this.root.querySelector('.HeaderSite-menuContents');
    this.productMenu = this.root.querySelector('.HeaderSite-productMenu');
    this.productMenuEnabled = false;
    this.productTitleEl = this.root.querySelector('.HeaderSite-productMenu__title');
    this.productPriceEl = this.root.querySelector('.HeaderSite-productMenu__price');
    this.productActionsEl = this.root.querySelector('.HeaderSite-productMenu__actions');
    this.productCtaSentinel = document.querySelector('.wc_single_product-main [data-fa-product-sector]');
    this.productSector = this.productCtaSentinel?.dataset.faProductSector || '';
    this.productMenuRightWrapper = document.querySelector('.HeaderSite-productMenu__right');

    if (!this.productCtaSentinel && this.productSector === 'trade') {
      this.productCtaSentinel = document.querySelectorAll('body.product-template-template-product-trade a.single-custom')[0];
    }
    this.productHeaderSentinel = document.querySelector('.wc_single_product-main');

    this._init();
  }

  _init() {
    this._bindEvents();
    this._initProductMenu();
  }

  _bindEvents() {
    window.addEventListener(
      'scroll',
      throttle(this._toggleStateClass.bind(this), 40, { leading: true, passive: true })
    );

    document.querySelector('.HeaderSite-mobileToggle').addEventListener('click', ev => {
      const isExpanded = ev.currentTarget.getAttribute('aria-expanded') === 'true';
      ev.currentTarget.setAttribute('aria-expanded', !isExpanded);
      ev.currentTarget.setAttribute('aria-label', !isExpanded ? 'Close mobile menu' : 'Open mobile menu');
      this.mobileMenu.classList.toggle('HeaderMobile--isOpen');
      this.root.classList.toggle('HeaderSite--mobileActive');
      document.body.classList.toggle('u-mobileMenuActive');
      this.mobileOpen = !this.mobileOpen;

      //document.body.style.overflowY = this.mobileOpen ? 'hidden' : 'scroll';
      document.body.style.height = this.mobileOpen ? '100vh' : 'auto';

    });

    [...document.querySelectorAll('.HeaderSite-desktopMenu .menu-item-has-children')].forEach(elem => {
      elem.addEventListener('mouseenter', ev => this._setDDState(1));
      elem.addEventListener('mouseleave', ev => this._setDDState());
      elem.addEventListener('focus', ev => this.root.classList.add('u-ddFocused'), true);
      elem.addEventListener('blur', ev => this.root.classList.remove('u-ddFocused'), true);
    });

  }

  _setDDState(enable) {
    this.root.classList[enable ? 'add' : 'remove']('u-ddActive')
  }

  _toggleStateClass() {
    const scrollDist = window.pageYOffset

    if (scrollDist > 220) {
      this.root.classList.add('HeaderSite--compact')
    } else {
      this.root.classList.remove('HeaderSite--compact')
    }
  }

  _initProductMenu() {
    if (!this.productMenu || !this.productTitleEl || !this.productPriceEl || !this.productActionsEl) return;
    if (!this.productCtaSentinel || !this.productHeaderSentinel) return;

    this._syncProductDetails();
    this._syncProductActions();
    this._syncProductMenuPosition();
    this._toggleProductMenu(this._shouldEnableProductMenu());

    

    window.addEventListener(
      'scroll',
      throttle(() => {
        this._syncProductMenuPosition();
        this._toggleProductMenu(this._shouldEnableProductMenu());
      }, 60, { leading: true, passive: true })
    );

    window.addEventListener('resize', throttle(() => {
      this._syncProductMenuPosition();
      this._syncProductActions();
      this._toggleProductMenu(this._shouldEnableProductMenu());
    }, 200));
  }

  _shouldEnableProductMenu() {    
    if (!this.productCtaSentinel || !this.productHeaderSentinel) return false;
    if (!this.productActionsEl || !this.productActionsEl.children.length) return false;

    const ctaRect = this.productCtaSentinel.getBoundingClientRect();
    const headerHeight = this.root.getBoundingClientRect().height;
    const ctaAboveHeader = ctaRect.bottom < headerHeight + 10;

    // Show only after the user has scrolled past the CTA block.
    return ctaAboveHeader;
  }

  _toggleProductMenu(shouldEnable) {
    if (!this.productMenu) return;
    if (this.productMenuEnabled === shouldEnable) return;

    this.productMenuEnabled = shouldEnable;
    this.root.classList.toggle('HeaderSite--productMenu', shouldEnable);
    this.productMenu.setAttribute('aria-hidden', shouldEnable ? 'false' : 'true');
    this._setInertState(this.productMenu, !shouldEnable);

    if (this.menuContents) {
      this.menuContents.setAttribute('aria-hidden', shouldEnable ? 'true' : 'false');
      this._setInertState(this.menuContents, shouldEnable);
    }
  }

  _setInertState(el, makeInert) {
    if (!el || !('inert' in el)) return;
    el.inert = makeInert;
  }

  _syncProductMenuPosition() {
    if (!this.productMenu || !this.mainMenu) return;

    const menuRect = this.mainMenu.getBoundingClientRect();
    this.productMenu.style.top = `${Math.round(menuRect.top)}px`;
    this.productMenu.style.height = `${Math.round(menuRect.height)}px`;
  }

  _syncProductDetails() {
    const title = document.querySelector('.wc_single_product-main h1');
    const price = document.querySelector('.wc_single_product-main .price');

    if (title) {
      this.productTitleEl.textContent = title.textContent.trim();
    }

    if (price) {
      this.productPriceEl.innerHTML = price.innerHTML;
    }
  }

  _syncProductActions() {
    const actionWrap = this.productCtaSentinel;
    if (!actionWrap) return;

    const buyButton = actionWrap.querySelector('.single-product-btns__buy');
    const preOrderButton = actionWrap.querySelector('.single_add_to_cart_button');
    const tradeButton = this.productSector === 'trade'
      ? (actionWrap.matches('a.single-custom') ? actionWrap : actionWrap.querySelector('a.single-custom'))
      : null;

    this.productActionsEl.innerHTML = '';
    this.productMenuRightWrapper.classList.remove('alt-text');

    if (buyButton) {
      const buyClone = buyButton.cloneNode(true);
      buyClone.classList.add('HeaderSite-productMenu__buy');
      buyClone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
      this.productActionsEl.appendChild(buyClone);
      return;
    }

    if (preOrderButton) {
      const preOrderClone = preOrderButton.cloneNode(true);
      preOrderClone.classList.add('HeaderSite-productMenu__buy');
      preOrderClone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
      preOrderClone.textContent = 'Pre-order now';
      this.productActionsEl.appendChild(preOrderClone);
      return;
    }

    if (tradeButton) {
      const tradeClone = tradeButton.cloneNode(true);
      tradeClone.classList.add('HeaderSite-productMenu__buy');
      tradeClone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
      this.productPriceEl.innerHTML = '';
      this.productMenuRightWrapper.classList.add('alt-text');
      tradeClone.textContent = 'Book a Specification Meeting';
      this.productActionsEl.appendChild(tradeClone);
    }
  }
}

new HeaderSite();
